import { apiClient } from 'services/api-client';

export const getFrameworks = async () => {
  return await apiClient.get(`/frameworks`);
};

export const getFrameworksInUse = async (companyId) => {
  return await apiClient.get(`/frameworks/in-use?companyId=${companyId}`);
};

export const getControlsGrouped = async (frameworksIds) => {
  const queryString = frameworksIds.join(",");
  return await apiClient.get(`/controls-framework/controls-grouped?frameworksIds=${queryString}`);
};

export const getGapAnalysisControl = async (idGap, idControl) => {
  return await apiClient.get(`/gap-analysis/${idGap}/controls-framework/${idControl}`);
}

export const updateMaturityLevel = async (idControl, maturityLevel) => {
  return await apiClient.put(`/gap-analysis/control/${idControl}/maturity`, { maturityLevel, });
};

export const updateStatusControl = async (idControl, status) => {
  return await apiClient.put(`/gap-analysis/control/${idControl}/status`, { status, });
};

export const updateStatusObjectiveControl = async (idObjective, objective) => {
  return await apiClient.put(`/gap-analysis/objective/${idObjective}/status`, { objective });
};


export const postGapAnalysis  = async (data) => {
  return await apiClient.post(`/gap-analysis`, data);
};

export const getGapAnalysis = async (tenant) => {
  return await apiClient.get(`/gap-analysis?companyKey=${tenant}`)
}

export const getGapAnalysisDetails = async (id) => {
  return await apiClient.get(`/gap-analysis/${id}/controls`)
}

export const getGapAnalysisControlsDetails = async (id) => {
  return await apiClient.get(`/gap-analysis/${id}/controls-framework`)
}

export const getGapAnalysisControlDetails = async (id) => {
  return await apiClient.get(`/gap-analysis/control/${id}`)
}

export const postGapAnalysisVinculo = async (id, data) => {
  return await apiClient.post(`/gap-analysis/${id}/vinculo`, data);
};

export const deleteGapAnalysisVinculo = async (id_vinculo) => {
  return await apiClient.delete(`/gap-analysis/vinculo/${id_vinculo}`);
};

export const getGapAnalysisDashboard = async (id) => {
  return await apiClient.get(`/gap-analysis/${id}/dashboard`);
};

export const postGapAnalysisReport = async (data) => {
  return await apiClient.post(`/gap-analysis/report`, data);
};

export const getGapAnalysisReport = async (id) => {
  return await apiClient.get(`/gap-analysis/report?companyKey=${id}`)
}

export const deleteGapAnalysisReport = async (id) => {
  return await apiClient.delete(`/gap-analysis/report/${id}`);
};

export const getGapAnalysisReportByID = async (id) => {
  return await apiClient.get(`/gap-analysis/report/${id}`)
}
